<template>
  <div style="padding: 10px; margin: 10px 0px; background: rgb(234, 241, 255)">
    <div class="summary-info">
      <div class="title-line"><span class="divider-title">沟通补充信息</span></div>

      <div v-if="moreItem && moreItem.caseCode" style="margin-top: 10px; height: 400px">
        <el-scrollbar style="height: 100%">
          <el-form ref="form" :model="moreItem" label-width="120px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="目前治疗情况">
                  <el-checkbox-group v-model="moreItem.currentTreatment">
                    <el-checkbox
                      v-for="(value, projectIndex) in projectData"
                      :key="projectIndex"
                      :label="value.id"
                      @change="chooseItem(value.id)"
                    >
                      {{ value.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="治疗费来源">
                  <el-checkbox-group v-model="moreItem.treatmentFeeSource">
                    <el-checkbox
                      v-for="(value, treatmentIndex) in treatmentFeeSource"
                      :key="treatmentIndex"
                      :label="value.id"
                      @change="chooseItem(value.id)"
                    >
                      {{ value.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="家庭收入">
                  <el-select v-model="moreItem.homeIncome" placeholder="请选择">
                    <el-option
                      v-for="(item, homeIndex) in homeIncome"
                      :key="homeIndex"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="治疗花费">
                  <el-select v-model="moreItem.treatCost" placeholder="请选择">
                    <el-option
                      v-for="(item, treatIndex) in treatCostType"
                      :key="treatIndex"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="会员生存现状">
                  <el-select v-model="moreItem.memberAliveStatus" placeholder="请选择">
                    <el-option
                      v-for="(item, memberAliveIndex) in memberAliveStatusType"
                      :key="memberAliveIndex"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="长期生活地点">
                  <el-cascader
                    ref="myCascader"
                    v-model="moreItem.lifeLocation.codes"
                    :options="areaOptions"
                    change-on-select
                    expand-trigger="hover"
                    @change="handleChange"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="症状">
                  <el-input v-model="moreItem.symptom" placeholder="症状" />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="首诊医院">
                  <el-input v-model="moreItem.firstHospital" placeholder="首诊医院" />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="邮箱归属">
                  <el-input v-model="moreItem.mailOwner" placeholder="邮箱归属人" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="调查服务评价">
                  <el-select
                    v-model="moreItem.surveyServiceEvaluation"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, serverLevesIndex) in serverLevesType"
                      :key="serverLevesIndex"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="推荐人">
                  <el-input v-model="moreItem.referrerName" placeholder="推荐人" />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="是否代理人">
                  <el-select v-model="moreItem.agentFlag" placeholder="请选择">
                    <el-option
                      v-for="(item, isTypeIndex) in isType"
                      :key="isTypeIndex"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="推荐人手机">
                  <el-input
                    v-model="moreItem.referrerPhoneNumber"
                    placeholder="推荐人手机"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="配合程度">
                  <el-select v-model="moreItem.cooperateDegree" placeholder="请选择">
                    <el-option
                      v-for="(item, cooperateIndex) in cooperateDegree"
                      :key="cooperateIndex"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="表达能力">
                  <el-select v-model="moreItem.expressionAbility" placeholder="请选择">
                    <el-option
                      v-for="(item, expressionIndex) in expressionAbility"
                      :key="expressionIndex"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row
              v-for="(checkItem, checkIndex) in moreItem && moreItem.medicalExamination"
              :key="checkIndex"
              :gutter="24"
            >
              <el-col :span="8">
                <el-form-item label="体检机构">
                  <el-input v-model="checkItem.examLocation" placeholder="体检机构" />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="体检时间">
                  <el-date-picker
                    v-model="checkItem.examDate"
                    type="date"
                    style="width: 150px"
                    placeholder="体检时间"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                  <i
                    v-if="
                      checkPermission('沟通补充信息:保存', permList) &&
                        checkIndex == moreItem.medicalExamination.length - 1
                    "
                    class="el-icon-circle-plus-outline"
                    @click="addMedicalExamination(checkIndex)"
                  />
                  <i
                    v-if="
                      checkPermission('沟通补充信息:保存', permList) &&
                        checkIndex !== moreItem.medicalExamination.length - 1
                    "
                    class="el-icon-remove-outline"
                    @click="reduceMedicalExamination(checkIndex)"
                  />
                </el-form-item>

                <el-col :span="8" />
              </el-col>
            </el-row>

            <div>
              <el-row
                v-for="(addInsuranceItem, addInsuranceIndex) in moreItem &&
                  moreItem.purchaseInsurance"
                :key="addInsuranceIndex"
                :gutter="24"
              >
                <el-col :span="8">
                  <el-form-item label="保险公司">
                    <el-input
                      v-model="addInsuranceItem.insuranceCompany"
                      placeholder="保险公司"
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="险种">
                    <el-input
                      v-model="addInsuranceItem.insuranceType"
                      placeholder="险种"
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="购买时间">
                    <el-date-picker
                      v-model="addInsuranceItem.buyTime"
                      type="date"
                      style="width: 150px"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                    />
                    <i
                      v-if="
                        checkPermission('沟通补充信息:保存', permList) &&
                          addInsuranceIndex == moreItem.purchaseInsurance.length - 1
                      "
                      class="el-icon-circle-plus-outline"
                      @click="addPurchaseInsurance(addInsuranceIndex)"
                    />

                    <i
                      v-if="
                        checkPermission('沟通补充信息:保存', permList) &&
                          addInsuranceIndex !== moreItem.purchaseInsurance.length - 1
                      "
                      class="el-icon-remove-outline"
                      @click="reducePurchaseInsurance(addInsuranceIndex)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <el-row>
              <el-col :span="12">
                <el-form-item label="治疗特殊性">
                  <el-input
                    v-if="checkPermission('沟通补充信息:保存', permList)"
                    v-model="moreItem.treatmentSpec"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                    placeholder="请输入内容"
                    maxlength="240"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="家庭特殊性">
                  <el-input
                    v-if="checkPermission('沟通补充信息:保存', permList)"
                    v-model="moreItem.familySpec"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                    placeholder="请输入内容"
                    maxlength="240"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="职业特殊性">
                  <el-input
                    v-if="checkPermission('沟通补充信息:保存', permList)"
                    v-model="moreItem.jobSpec"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                    placeholder="请输入内容"
                    maxlength="240"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="沟通过程中给人的特殊感觉">
                  <el-input
                    v-if="checkPermission('沟通补充信息:保存', permList)"
                    v-model="moreItem.communicateSpecFeel"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                    placeholder="请输入内容"
                    maxlength="240"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col>
                <el-form-item label="修改历史">
                  <el-timeline
                    v-if="moreItem.specInfos != null"
                    style="margin-top: 15px"
                    :reverse="true"
                  >
                    <el-timeline-item
                      v-for="(history, historyIndex) in moreItem && moreItem.specInfos"
                      :key="historyIndex"
                    >
                      <h6
                        v-for="(r, rIndex) in history && history.historyMsg"
                        :key="rIndex"
                      >
                        <p>{{ r }}</p>
                      </h6>
                      <p>{{ history.editor }} 提交于 {{ history.remarkTime }}</p>
                    </el-timeline-item>
                  </el-timeline>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col>
                <el-form-item label="摘要">
                  <el-input
                    v-if="checkPermission('沟通补充信息:保存', permList)"
                    v-model="moreItem.remarkMsg"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10 }"
                    placeholder="请输入内容"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col>
                <el-form-item label="摘要历史">
                  <el-timeline style="margin-top: 15px" :reverse="true">
                    <el-timeline-item
                      v-for="(remarkItem, remarkIndex) in moreItem && moreItem.remark"
                      :key="remarkIndex"
                    >
                      <h6>{{ remarkItem.remarkMsg }}</h6>
                      <p>{{ remarkItem.editor }} 提交于 {{ remarkItem.remarkTime }}</p>
                    </el-timeline-item>
                  </el-timeline>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col>
                <el-form-item>
                  <el-button
                    v-if="checkPermission('沟通补充信息:保存', permList)"
                    type="primary"
                    icon="el-icon-edit"
                    @click.stop="save"
                  >
                    保存
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import areajson from '@/assets/js/select_area'

export default {
  props: {
    caseCode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      serverLevesType: [
        { name: '请选择', code: 0 },
        { name: '满意', code: 1 },
        { name: '不满意', code: 2 }
      ],
      isType: [
        { name: '请选择', code: 0 },
        { name: '是', code: 1 },
        { name: '否', code: 2 }
      ],
      treatmentFeeSource: [
        { name: '积蓄', id: 1 },
        { name: '借款', id: 2 },
        { name: '医保及商业保险', id: 3 },
        { name: '放弃治疗', id: 4 }
      ],
      cooperateDegree: [
        { name: '请选择', code: 1 },
        { name: '配合意愿高，愿意拍摄视频并且宣传', code: 2 },
        { name: '配合意愿一般，可以接受站内的真实性展示(探访等)', code: 3 },
        { name: '配合意愿低，需要多次沟通后才接受配合', code: 4 }
      ],
      expressionAbility: [
        { name: '请选择', code: 1 },
        { name: '表达能力强，说话清晰，能清楚表达个人情况及治疗情况', code: 2 },
        { name: '表达能力一般，有当地口音，能表达个人情况', code: 3 },
        { name: '表达能力弱，需要人协助才能表达清楚', code: 4 }
      ],
      homeIncome: [
        { name: '请选择', code: 1 },
        { name: '5万以下', code: 2 },
        { name: '5万-10万', code: 3 },
        { name: '10万-20万', code: 4 },
        { name: '20万以上', code: 5 }
      ],
      treatCostType: [
        { name: '请选择', code: 1 },
        { name: '5万以下', code: 2 },
        { name: '10万以下', code: 3 },
        { name: '20万以下', code: 4 },
        { name: '20万以上', code: 5 }
      ],
      memberAliveStatusType: [
        { name: '请选择', code: 1 },
        { name: '健在', code: 2 },
        { name: '已故', code: 3 }
      ],
      checkedItem: [1, 3],
      projectData: [
        { name: '手术', id: 1 },
        { name: '化疗', id: 2 },
        { name: '放疗', id: 3 },
        { name: '靶向', id: 4 },
        { name: '保守治疗', id: 5 }
      ],
      addCheckList: [],
      currentMedicalExamination: {
        examDate: '',
        examLocation: ''
      },

      addInsuranceList: [],
      currentPurchaseInsurance: {
        insuranceCompany: '',
        insuranceType: '',
        buyTime: ''
      },
      areaOptions: areajson,
      selectArea: [],
      moreItem: {
        lifeLocation: {
          name: '',
          codes: []
        },
        medicalExamination: [],
        purchaseInsurance: [],
        currentTreatment: [],
        treatmentFeeSource: []
      },
      remarkMsg: '',
      treatmentSpec: '',
      familySpec: '',
      jobSpec: '',
      communicateSpecFeel: ''
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    })
  },

  created() {
    this.get()
  },

  methods: {
    handleChange(val) {
      console.info(this.$refs['myCascader'].inputValue)
    },

    chooseItem(id) {
      // if(this.arr.indexOf(id)==-1){
      // 	this.arr.push(id)
      // }else{
      // 	this.arr.splice(this.arr.indexOf(id), 1);
      // }
      // this.addData.project_name=this.arr.join(',')
    },

    addPurchaseInsurance(index) {
      // eslint-disable-next-line eqeqeq
      if (this.moreItem.purchaseInsurance[index].insuranceCompany == '') {
        this.$alert('请先填写保险公司名')
        return
      }

      this.moreItem.purchaseInsurance.push(
        Object.assign({}, this.currentPurchaseInsurance)
      )
    },

    reducePurchaseInsurance(index) {
      this.moreItem.purchaseInsurance.splice(index, 1)
    },

    addMedicalExamination(index) {
      // eslint-disable-next-line eqeqeq
      if (this.moreItem.medicalExamination[index].examLocation == '') {
        this.$alert('请先填写体检机构名')
        return
      }
      this.moreItem.medicalExamination.push(
        Object.assign({}, this.currentMedicalExamination)
      )
    },

    reduceMedicalExamination(index) {
      this.moreItem.medicalExamination.splice(index, 1)
    },

    /**
     * 沟通补充信息-查找
     */
    get() {
      const vm = this
      const currentPurchaseInsurance = {
        insuranceCompany: '',
        insuranceType: '',
        buyTime: ''
      }
      vm.currentMedicalExamination = { examDate: '', examLocation: '' }
      vm.currentPurchaseInsurance = currentPurchaseInsurance

      vm.axios
        .get(vm.homePath() + '/communicate/supplement/' + vm.caseCode)
        .then((res) => {
          if (res.data.status === '000000') {
            const result = res && res.data && res.data.data
            if (result.lifeLocation == null) {
              result.lifeLocation = {
                name: '',
                codes: []
              }
            }
            if (result.medicalExamination == null) {
              result.medicalExamination = []
              result.medicalExamination.push(
                Object.assign({}, vm.currentMedicalExamination)
              )
            }
            if (result.purchaseInsurance == null) {
              result.purchaseInsurance = []
              result.purchaseInsurance.push(
                Object.assign({}, vm.currentPurchaseInsurance)
              )
            }

            if (result.currentTreatment == null) {
              result.currentTreatment = []
            }
            if (result.treatmentFeeSource == null) {
              result.treatmentFeeSource = []
            }

            vm.moreItem = result
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    // ====================保存操作====================
    // 保存补充更多资料
    save() {
      /* if (this.currentPurchaseInsurance.insuranceCompany != "") {
                    this.addPurchaseInsurance();
                }
                if (this.currentMedicalExamination.examLocation != "") {
                    this.addMedicalExamination();
                } */
      const vm = this
      const areaName = vm.$refs['myCascader'].inputValue
      // eslint-disable-next-line eqeqeq
      if (areaName != null && areaName != vm.moreItem.lifeLocation.name) {
        vm.moreItem.lifeLocation.name = areaName
      }

      vm.axios({
        url: vm.homePath() + '/communicate/supplement/modify',
        method: 'put',
        data: vm.moreItem,
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status === '000000') {
            vm.$alert('修改成功')
            vm.get()
          } else {
            vm.$alert(result.message)
          }
        })
        .catch((error) => console.log(error))
    }
  }
}
</script>

<style>
.el-form-item {
  margin-bottom: 12px !important;
}

.el-scrollbar__wrap {
  overflow-x: hidden;
  margin-bottom: -5px !important;
}

.el-textarea {
  width: 80% !important;
}
</style>
